"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var moment = require("moment");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var ParBrandsLandingsListCtl = /** @class */ (function (_super) {
    __extends(ParBrandsLandingsListCtl, _super);
    function ParBrandsLandingsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_cms_image_url = UIUtils_1.UIUtils.IProp2Str(function (o) { o.cms_image_url; });
        _this.dk_landing_identity = UIUtils_1.UIUtils.IProp2Str(function (o) { o.landing_identity; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this.dk_is_deprecated = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_deprecated; });
        _this.dk_is_all_country = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_all_country; });
        _this.dk_countries_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.countries_count; });
        _this.dk_order_number = UIUtils_1.UIUtils.IProp2Str(function (o) { o.order_number; });
        _this.dk_is_main_page = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_main_page; });
        _this._errDialog = errDialog;
        return _this;
    }
    ParBrandsLandingsListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0,
            cdn_baseurl: ""
        };
    };
    ParBrandsLandingsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "brand landing with id [" + id + "] not found !";
    };
    ParBrandsLandingsListCtl.prototype.LoadData = function (AllBrands, BrandIdList, onDone) {
        var _this = this;
        webAApi_1.ListBrandLandingsByBrandsGet.exec({
            all_brands: AllBrands,
            brand_id_list: BrandIdList
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            _this.DATA.cdn_baseurl = resp.cdn_baseurl;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    title: resp.list[i].title,
                    cms_image_url: resp.list[i].cms_image_url,
                    landing_identity: resp.list[i].landing_identity,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    is_deprecated: resp.list[i].is_deprecated,
                    is_all_country: resp.list[i].is_all_country,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    countries_count: resp.list[i].countries_count,
                    order_number: resp.list[i].order_number,
                    is_main_page: resp.list[i].is_main_page
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    ParBrandsLandingsListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBrandLanding.exec({
            data: {
                title: data.title,
                brand_id: data.brand_id,
                cms_image_url: data.cms_image_url,
                landing_identity: data.landing_identity,
                is_deprecated: data.is_deprecated,
                is_all_country: data.is_all_country,
                order_number: data.order_number,
                is_main_page: data.is_main_page
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                cms_image_url: data.cms_image_url,
                landing_identity: data.landing_identity,
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                date_changed2: moment(resp.date_changed_uts_ms).utc(false),
                is_deprecated: data.is_deprecated,
                is_all_country: data.is_all_country,
                brand_id: data.brand_id,
                brand_title: resp.brand_title,
                title: data.title,
                countries_count: 0,
                order_number: data.order_number,
                is_main_page: data.is_main_page
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    ParBrandsLandingsListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditBrandLanding.exec({
                data: {
                    brands_aff_landing_id: data.key,
                    cms_image_url: data.cms_image_url,
                    landing_identity: data.landing_identity,
                    is_deprecated: data.is_deprecated,
                    is_all_country: data.is_all_country,
                    title: data.title,
                    order_number: data.order_number,
                    is_main_page: data.is_main_page
                }
            }, function (resp) {
                _tmp.cms_image_url = data.cms_image_url;
                _tmp.title = data.title;
                _tmp.landing_identity = data.landing_identity;
                _tmp.is_deprecated = data.is_deprecated;
                _tmp.is_all_country = data.is_all_country;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.order_number = data.order_number;
                _tmp.is_main_page = data.is_main_page;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    ParBrandsLandingsListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    ParBrandsLandingsListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteBrandLanding.exec({
                data: {
                    brands_aff_landing_id: key
                }
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    ParBrandsLandingsListCtl.prototype.doSetIsDeprecated = function (key, isDeprecated, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetBrandLandingIsDeprecated.exec({
                data: {
                    brands_aff_landing_id: key,
                    is_deprecated: isDeprecated
                }
            }, function (resp) {
                _tmp.is_deprecated = isDeprecated;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    ParBrandsLandingsListCtl.prototype.doSetOrderNumber = function (key, OrderNumber, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetBrandLandingPriority.exec({
                data: {
                    brand_partner_landing_id: key,
                    order_number: OrderNumber
                }
            }, function (resp) {
                _tmp.order_number = OrderNumber;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return ParBrandsLandingsListCtl;
}(BaseController_1.BaseController));
exports.ParBrandsLandingsListCtl = ParBrandsLandingsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_brands_landings_list/ctl/ParBrandsLandingsListCtl.ts
// module id = 956
// module chunks = 0